import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { NGXLogger } from 'ngx-logger';
import { environment } from '../../../environments/environment';

function getAccessTokenExpMs(token: string | null): number | null {
  if (!token) {
    return null;
  }

  try {
    const payload = JSON.parse(atob(token.split('.')[1] || ''));
    if (typeof payload?.exp !== 'number') {
      return null;
    }

    return payload.exp * 1000;
  } catch {
    return null;
  }
}

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  
  // const errorHandlerSv = inject(ErrorHandlerService);
  const toast = inject(ToastService);
  const logger: NGXLogger = inject(NGXLogger);

  return next(req).pipe(
    tap({
      next: (event) => {
        if(event instanceof HttpResponse) {
          // toast.show('Success.', 'Http request success', 'success');
        }
      },
      error: (error: HttpErrorResponse) => {
        // console.log('Handler: ', error.error.error.message)
        if (error.status === 401) {
          const token = localStorage.getItem('access_token');
          const expMs = getAccessTokenExpMs(token);
          const now = Date.now();

          const diagnostics = {
            requestUrl: req.url,
            currentUrl: window.location.href,
            tokenPresent: Boolean(token),
            tokenExpMs: expMs,
            tokenExpired: typeof expMs === 'number' ? expMs <= now : null,
            tokenTimeLeftMs: typeof expMs === 'number' ? expMs - now : null,
            hasAuthorizationHeader: req.headers.has('Authorization'),
            withCredentials: req.withCredentials
          };

          console.warn('[AuthDiagnostics] 401 response detected.', diagnostics);
        }

        toast.show('Error.', error.error.error.message, 'error');
        /**
         * Storing logs only for production mode
         */
        if(environment.production) {
          logger.error('HTTP Error ', {
            url: req.url,
            status: error.status,
            message: error.message,
            error: error.error
          });
        }
      }
    })
  )
  
};
